<template>
  <pl-dialog
    :title="`Which ${integration_name}  courses do you want to import to Parlay?`"
    :size="'xl'"
    @close="$emit('close')"
    :disableOutsideClick="true"
  >
    <!-- <div style="position: absolute; right: 0; top: 0">
      <pl-button @click.native="$emit('close')" style="min-width: 50px">
        <i class="fas fa-times fa-3x" style="color: #595959"></i>
      </pl-button>
    </div> -->
    <body class="px-7 pt-7 pb-4 flex-grow overflow-y-auto">
      <!-- <div class="pt-4 px-3"> -->
      <div class="flex">
        <span class="col-xs-10 sub-header">
          Import courses will automatically create accounts for teachers and
          students in those courses (if the account don’t already exist), and
          roster the courses accordingly.
        </span>
        <div class="col-xs-2">
          <pl-spinner
            v-if="loading_update_data"
            style="margin: auto"
            class="x1"
          />
          <pl-button
            v-else
            class="w-100 pl-primary-font b"
            @click.native="edlinkSchoolIntegrationCourses"
            style="
              margin: 0;
              border-bottom: 2px solid #d9d9d9;
              border-right: 2px solid #d9d9d9;
            "
          >
            <i class="fas fa-redo mr2"></i>
            Update Data
          </pl-button>
        </div>
      </div>
      <!-- </div> -->
      <div v-if="courses" class="mt3 ph3">
        <admin-portal-integrations-filters-bar
          class="mb-3"
          :coursesFilters="coursesFilters"
          @filters="filters"
          @admin-portal-filter-changed="resetFilters"
        />
        <table v-if="courses.length" class="courses-table w-100">
          <thead>
            <tr class="row no-margin middle-xs">
              <td class="col-xs-1" style="padding-left: 10px">
                <pl-checkbox
                  v-model="allSelected"
                  @change="handleSelectAll($event)"
                  class="col-xs-1"
                />
              </td>
              <td class="col-xs-3">Course & Section</td>
              <td class="col-xs-2">Teacher</td>
              <td class="col-xs-2">Co-Teachers</td>
              <td class="col-xs-1">Subject</td>
              <td class="col-xs-1">School / Site</td>
              <td class="col-xs-1">Grade</td>
              <td class="col-xs-1">Students</td>
            </tr>
          </thead>
          <tbody
            id="integrations-course-modal"
            @scroll="$emit('scroll-on-table')"
          >
            <tr
              class="row no-margin"
              v-for="(course, index) in courses"
              :key="index"
            >
              <td class="col-xs-1">
                <pl-checkbox
                  v-model="selectedCourses[index]"
                  @change="handleSelectCourse($event, index)"
                  class="col-xs-1"
                />
              </td>
              <td class="col-xs-3">
                {{ course.title }}
              </td>
              <td class="col-xs-2">
                <div
                  v-if="course.teacher_email"
                  :title="course.teacher_email"
                  class="truncate-text"
                >
                  {{ course.teacher_email }}
                </div>
                <div v-else>-</div>
              </td>
              <td class="col-xs-2">
                <div
                  v-if="
                    course.co_teachers_emails &&
                    course.co_teachers_emails.length
                  "
                >
                  <div
                    v-for="(co_teacher, index) in course.co_teachers_emails"
                    :key="index"
                    :title="co_teacher"
                    class="truncate-text"
                  >
                    {{ co_teacher }}
                  </div>
                </div>
                <div v-else>-</div>
              </td>
              <td class="col-xs-1">
                <div v-if="course.subjects && course.subjects.length">
                  <div
                    v-for="(subject, index) in course.subjects"
                    :key="index"
                    :title="subject"
                    class="truncate-text"
                  >
                    {{ subject }}
                  </div>
                </div>
                <div v-else>-</div>
              </td>
              <td class="col-xs-1 truncate-text" :title="course.school_site">
                {{ course.school_site }}
              </td>
              <td class="col-xs-1">
                <div v-if="course.grades && course.grades.length">
                  <div
                    v-for="(grade, index) in course.grades"
                    :key="index"
                    :title="grade"
                    class="truncate-text"
                  >
                    {{ grade }}
                  </div>
                </div>
                <div v-else>-</div>
              </td>
              <td class="col-xs-1 center-xs">
                {{ course.students_count }}
              </td>
            </tr>
          </tbody>
        </table>
        <div v-else class="row middle-xs center-xs no-courses-text ph5">
          Parlay has not received any course or user information from this
          integration yet. If you recently enabled the integration, it can take
          up to 24 hours for the data to propagate.
        </div>
      </div>
    </body>
    <footer class="flex my-8 center items-center">
      <pl-spinner v-if="loading" style="margin: auto" class="x2" />
      <button
        v-else
        class="px-8 py-2 bg-primary rounded cursor-pointer text-white font-semibold"
        @click="importCourses"
        :disabled="(courses && !courses.length) || !selected_courses.length"
      >
        Import Courses to Parlay
      </button>
    </footer>
  </pl-dialog>
</template>
<script>
  import { EventBus } from 'utils/event-bus';
  import adminPortalIntegrationsFiltersBar from './adminPortalIntegrationsFiltersBar.vue';
  import adminServices from 'services/admin/adminServices';
  import { mapGetters } from 'vuex';

  export default {
    components: {
      adminPortalIntegrationsFiltersBar,
    },
    watch: {
      courses() {
        const is_selected = this.selectedCourses.filter((s) => s === true);
        this.allSelected = is_selected.length === this.courses.length;
      },
    },
    data() {
      return {
        allSelected: false,
        coursesFilters: {},
        loading: false,
        selectedCourses: [],
        loading_update_data: false,
      };
    },
    props: {
      courses: {
        type: Array,
        default() {
          return [];
        },
      },
      integration_id: {
        type: String,
        default() {
          return null;
        },
      },
      integration_name: {
        type: String,
        default() {
          return '';
        },
      },
    },
    computed: {
      ...mapGetters(['getCurrentSchool']),
      selected_courses() {
        return this.selectedCourses.filter((s) => s === true);
      },
      validMembership() {
        return (
          new Date(
            this.getCurrentSchool.membership[0].school_membership.end_date
          ) > new Date()
        );
      },
    },
    methods: {
      handleSelectAll(status) {
        this.selectedCourses = this.courses.map(() => status);
        const is_selected = this.selectedCourses.filter((s) => s === true);
        this.allSelected = is_selected.length === this.courses.length;
      },
      handleSelectCourse(event, index) {
        let boolean_status = false;
        if (event === 'on' || event == true) {
          boolean_status = true;
        } else {
          boolean_status = false;
        }
        if (typeof index === 'number') {
          const status = [...this.selectedCourses];
          status[index] = boolean_status;
          this.selectedCourses = status;
          this.allSelected =
            this.selected_courses.length === this.courses.length;
        }
      },
      getEdlinkSchoolIntegrationCoursesFilters() {
        const payload = {
          schoolID: this.$route.params.schoolID,
          integrationID: this.integration_id,
        };
        this.$store
          .dispatch('getEdlinkSchoolIntegrationCoursesFilters', payload)
          .then((data) => (this.coursesFilters = data));
      },
      async edlinkSchoolIntegrationCourses() {
        const schoolID = this.$route.params.schoolID;
        const integrationID = this.integration_id;
        const res =
          await adminServices.populateEdlinkSchoolIntegrationCoursesJob(
            schoolID,
            integrationID
          );
        if (res.data.id) {
          this.loading_update_data = true;
          let state = '';
          do {
            await this.sleep(1000);
            const response =
              await adminServices.getPopulateEdlinkSchoolIntegrationCoursesJobStatus(
                schoolID,
                integrationID,
                res.data.id
              );
            state = response.data.state;
          } while (state !== 'completed' && state !== 'failed');
          if (state === 'completed') {
            this.loading_update_data = false;
            EventBus.$emit('toast-msg', 'Courses successfully imported.');
            this.$emit(
              'load_edlink_courses',
              this.integration_id,
              this.integration_name
            );
          } else if (state === 'failed') {
            this.loading_update_data = false;
            EventBus.$emit(
              'toast-msg',
              'An error has occurred while importing courses from edLink.'
            );
          }
        }
      },
      async importCourses() {
        const schoolID = this.$route.params.schoolID;
        const integrationID = this.integration_id;

        const courses_to_import = this.courses.filter(
          (s, index) => this.selectedCourses[index]
        );
        const payload = {
          courses: courses_to_import,
        };
        let n_teachers = courses_to_import.map(
          (x) => x.co_teachers_emails.length
        );
        n_teachers = n_teachers.reduce((a, b) => a + b, 0);
        courses_to_import.map((x) => {
          x.teacher_email ? (n_teachers = n_teachers + 1) : null;
        });
        if (!this.getCurrentSchool.membership.length) {
          EventBus.$emit('toast-msg', `Your school has no membership`);
        }
        const { number_of_licenses, licenses_used, membership_type } =
          this.getCurrentSchool.membership[0].school_membership;
        let available_licenses = number_of_licenses - licenses_used;
        if (n_teachers > 0 && !this.validMembership) {
          EventBus.$emit('toast-msg', `Your school membership has expired`);
        }
        if (membership_type === 'teacher') {
          if (available_licenses < n_teachers) {
            let teachers_emails = courses_to_import.map((x) =>
              x.co_teachers_emails.concat(x.teacher_email)
            );
            teachers_emails = [].concat.apply([], teachers_emails);

            const {
              data: { school_used_licenses },
            } = await adminServices.getTeachersWithLicense(
              this.getCurrentSchool.id,
              { teachers_emails }
            );
            const new_teacher_licenses = n_teachers - school_used_licenses;
            if (available_licenses < new_teacher_licenses) {
              EventBus.$emit(
                'toast-msg',
                `You have ${available_licenses} available licenses`
              );
              return;
            }
          }
        }

        const res = await adminServices.rosterSchoolDataJob(
          schoolID,
          integrationID,
          payload
        );
        if (res.data.id) {
          this.loading = true;
          let state = '';
          do {
            await this.sleep(1000);
            const response = await adminServices.getRosterSchoolDataJobStatus(
              schoolID,
              integrationID,
              res.data.id
            );
            state = response.data.state;
          } while (state !== 'completed' && state !== 'failed');
          if (state === 'completed') {
            this.loading = false;
            EventBus.$emit('toast-msg', 'Courses successfully imported.');
            this.$store.dispatch('getSchoolDetails', schoolID);
            this.$emit('close');
          } else if (state === 'failed') {
            this.loading = false;
            EventBus.$emit(
              'toast-msg',
              'An error has occurred while importing courses from edLink.'
            );
          }
        }
      },
      filters(value) {
        this.$emit('filters', value);
      },
      resetFilters() {
        this.$emit('admin-portal-filter-changed');
      },
      sleep(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
      },
    },
    mounted() {
      this.getEdlinkSchoolIntegrationCoursesFilters();
    },
  };
</script>
<style lang="stylus" scoped>
  @import '~app/global-stylus.styl';
  .header
    font-size: 24px
    line-height: 29px
    color: #273248
  .sub-header
    font-size: 18px
    line-height: 22px
    color: #273248
  .no-courses-text
    height: calc(85vh - 260px)
    font-size: 24px
    line-height: 29px
    color: #595959
  .courses-table
    tbody
      display: block
      overflow-y: auto
      height: calc(85vh - 290px)
      tr
        border: 2px solid #d9d9d9
        border-bottom: none
        align-items: center
        &:last-child
          border-bottom: 2px solid #d9d9d9
      td
        padding: 16px 8px
        font-weight: 500
  .footer
    border-top: 1px solid #979797
</style>



// WEBPACK FOOTER //
// integrationsCoursesModal.vue?e62430f0